import { createFileRoute, redirect } from "@tanstack/react-router"

import { LINKS } from "@/routing/links"
import { findAllPhotosForSession, getClaimDetailsByMarker, getClaimMarkersBySession } from "@/services/dexie"

// Resume the claim flow at the first incomplete sub-step, based on the locally hydrated Dexie state
async function resolveClaimResumeLink(sessionId: string): Promise<string> {
  const claimPhotos = (await findAllPhotosForSession(sessionId)).filter((p) => p.type === "Claim" && !p.deleted)
  if (claimPhotos.length === 0) {
    return LINKS.claimNew(sessionId)
  }

  const markers = await getClaimMarkersBySession(sessionId)

  // A claim photo that has no marker yet — draw the first marker on it
  const markerPhotoIds = new Set(markers.map((marker) => marker.photoId))
  const photoWithoutMarker = claimPhotos.find((photo) => !markerPhotoIds.has(photo.id))
  if (photoWithoutMarker) {
    return LINKS.claimNewMarker(sessionId, photoWithoutMarker.id)
  }

  // A marker with no detail yet — capture its details
  for (const marker of markers) {
    const details = await getClaimDetailsByMarker(marker.id)
    if (details.length === 0) {
      return LINKS.claimMarkerDetails(sessionId, marker.id)
    }
  }

  return LINKS.claimOverview(sessionId)
}

export const Route = createFileRoute("/$sessionId/_session/claim/")({
  beforeLoad: async ({ params }) => {
    const target = await resolveClaimResumeLink(params.sessionId)
    throw redirect({ to: target })
  },
})
